import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import { Step3BNotHoldWrapper } from './Step3BNotHoldStyled'
import {
  BackArrowWrapper, ColorText, ConditionView,
  Container,
  FormBigTitle,
  FormLabel,
  FormRequired,
  FormWrapper, TextInform, TextPrimaryInform,
} from '../CommonStyled/CommonStyled'
import IMAGES from '../../images'
import { Button, Col, Form, Input, notification, Row, Select } from 'antd'
import AccountInfo from '../AccountInfo'
import { BREAKPOINT, ERROR_COLOR, ERROR_TITLE, PAGES, SELECT_DOCUMENT_TYPE_LIST, TEMPLATE_CODE } from '../../constant'
import { useRecoilValue, useResetRecoilState } from 'recoil'
import { breakPointState } from '../../recoil/commonState'
import OtpForm from '../OtpForm'
import ConditionRender from '../ConditionRender'
import StepFinal from '../StepFinal'
import validator from '../../validator'
import { branchState, districtState, provinceState, wardsState } from '../../recoil/landingPageState'
import stringUtils from '../../utils/stringUtils'
import accountStore from '../../stores/accountStore'
import moment from 'moment'

const Step3BNotHold = forwardRef((props, ref) => {
  const { onClickBack, customerInfo, accountInfo, onCancel } = props
  const breakPoint = useRecoilValue(breakPointState)
  const [form] = Form.useForm()

  const listProvince = useRecoilValue(provinceState)
  const listDistrict = useRecoilValue(districtState)
  const listWard = useRecoilValue(wardsState)
  const listBranch = useRecoilValue(branchState)

  const resetProvince = useResetRecoilState(provinceState)
  const resetDistrict = useResetRecoilState(districtState)
  const resetWard = useResetRecoilState(wardsState)
  const resetBranch = useResetRecoilState(branchState)

  const [progressStep, setProgressStep] = useState(1)
  const [payloadData, setPayloadData] = useState(null)
  const [resendOtpData, setResendOtpData] = useState(null)
  const [finalContent, setFinalContent] = useState({})

  const resetForm = () => {
    form.resetFields()
    setProgressStep(1)
    setPayloadData(null)
    setResendOtpData(null)
    setFinalContent({})
  }

  useImperativeHandle(ref, () => ({
    resetForm,
  }))

  const handleClickBack = () => {
    setProgressStep(1)
    onClickBack()
  }
  const handleClickCancel = () => {
    setProgressStep(1)
    onCancel()
  }
  const handleSubmit = (values) => {
    let payloadSendOtp = {
      businessNumber: values?.legalId,
      targetReceiveOtp: values?.email,
      templateCode: TEMPLATE_CODE,
    }
    accountStore.sendOtp(payloadSendOtp)
      .then(res => {
        let payloadToHold = {
          ...values,
          fee: accountInfo?.reducedFee,
          accountNumber: accountInfo.accountNumber,
          checkToken: res.data.code,
          province: listProvince.find(item => item?.provinceId == values.provinceId)?.description,
          district: listDistrict.find(item => item?.districtId == values.districtId)?.description,
          ward: listWard.find(item => item?.wardId == values.wardId)?.description,
          branchName: listBranch.find(item => item?.code == values.branchCode)?.name,
        }
        setPayloadData(payloadToHold)

        setResendOtpData({
          checkToken: res.data.code,
          templateCode: TEMPLATE_CODE,
        })
        setProgressStep(2)
      })
      .catch(error => {
        if (error?.response?.data?.statusCode == '401') {
          onCancel && onCancel()
        }
      })
  }
  const handleCallbackResend = (res) => {
    let newPayloadData = { ...payloadData, checkToken: res?.data?.checkToken }
    let newResendOtpData = { ...resendOtpData, checkToken: res?.data?.checkToken }
    setPayloadData(newPayloadData)
    setResendOtpData(newResendOtpData)
  }
  const handleSubmitOTP = (otp) => {
    let payloadVerify = {
      moduleCode: 'SPECIAL_ACCOUNT',
      checkToken: payloadData.checkToken,
      businessNumber: payloadData.legalId,
      otp: otp,
    }
    accountStore.verifyOtp(payloadVerify)
      .then(resVerify => {
        if (resVerify?.data?.result === true) {
          accountStore.onHoldAccount(payloadData)
            .then(res => {
              if (res?.statusCode == '200') {
                let content = {
                  textLine1A: 'Chúc mừng Quý khách đã đăng ký sử dụng Tài khoản',
                  variableLine1: accountInfo?.accountNumber,
                  textLine2: `Vui lòng hoàn thiện hồ sơ theo hướng dẫn của Nhân viên tư vấn trước 17h:00 ${moment(res?.data?.expiryDate, 'YYYY-MM-DD').format('DD/MM/YYYY')} để được chính thức sở hữu.`,
                  textLine3: 'Sau thời gian trên, nếu Quý khách chưa cung cấp đủ hồ sơ đăng ký thì Số tài khoản này sẽ không còn thuộc sở hữu của Quý khách.',
                  buttonText: 'Trở lại trang giới thiệu',
                  buttonLink: PAGES.HOME.PATH,
                }
                setFinalContent(content)
                setProgressStep(3)
              }
            })
        } else {
          notification.error({
            message: <ColorText fontSize={'20px'} color={ERROR_COLOR}>{ERROR_TITLE}</ColorText>,
            description: resVerify?.data?.messageCode,
          })
        }
      })
      .catch(error => {
        if (error?.response?.data?.statusCode == '401') {
          onCancel && onCancel()
        }
      })
  }

  const handleChangeProvince = (e) => {
    if (!e) {
      form.setFieldsValue({
        districtId: null,
        wardId: null,
        branchCode: null,
      })
      resetDistrict()
      resetWard()
      resetBranch()
      return
    }
    resetWard()
    resetBranch()
    form.setFieldsValue({
      districtId: null,
      wardId: null,
      branchCode: null,
    })
    accountStore.getDistrict(e)
    accountStore.getBranch(e)
  }
  const handleChangeDistrict = (e) => {
    if (!e) {
      resetWard()
      form.setFieldsValue({
        wardId: null,
      })
      return
    }
    form.setFieldsValue({
      wardId: null,
    })
    accountStore.getWard(e)
  }

  useEffect(() => {
    if (!customerInfo) return
    form.setFieldsValue({
      documentType: customerInfo.documentType,
      legalId: customerInfo?.legalId,
    })
  }, [customerInfo])

  useEffect(() => {
    accountStore.getProvince()
  }, [])

  useEffect(() => {
    // form.setFieldsValue({
    //   customerName: 'aaa',
    //   contact: 'aaa',
    //   email: 'aaa@gmail.com',
    //   phoneNumber: '0379631004',
    // })
    return () => {
      resetProvince()
      resetDistrict()
      resetWard()
    }
  }, [])


  return (
    <Step3BNotHoldWrapper>
      <Container>
        <FormWrapper>
          {
            (progressStep === 1) &&
            <BackArrowWrapper>
              <img src={IMAGES.BACK_ARROW} alt={'back'} onClick={handleClickBack} />
            </BackArrowWrapper>
          }
          <ConditionRender visible={progressStep === 1}>
            <Row justify={'center'}>
              <Col xs={24} sm={24} md={24} lg={22} xl={22} xxl={20}>
                <AccountInfo accountNumber={accountInfo?.accountNumber} fee={accountInfo?.reducedFee} />
                <FormBigTitle
                  margin={'48px 0 40px 0'}
                  textAlign={'center'}>
                  Thông tin Quý khách hàng
                </FormBigTitle>
                <Form
                  form={form}
                  layout={'vertical'}
                  onFinish={handleSubmit}
                >
                  <Row
                    gutter={[
                      { xs: 8, sm: 8, md: 8, lg: 8, xl: 8, xxl: 8 },
                      { xs: 8, sm: 8, md: 8, lg: 8, xl: 8, xxl: 8 },
                    ]}
                    justify={{
                      xs: 'center',
                      sm: 'center',
                      md: 'center',
                      lg: 'center',
                      xl: 'center',
                      xxl: 'center',
                    }}
                    align={'bottom'}
                  >
                    {/*<Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>*/}
                    {/*  <Form.Item*/}

                    {/*    label={<>*/}
                    {/*      <FormLabel>Loại giấy tờ</FormLabel>*/}
                    {/*      <FormRequired> * </FormRequired>*/}
                    {/*    </>}*/}
                    {/*    rules={[{ validator: validator.validateDocumentType }]}*/}
                    {/*    name={'documentType'}*/}
                    {/*  >*/}
                    {/*    <Select*/}
                    {/*      placeholder={'Chọn'}*/}
                    {/*      style={{ height: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'auto' : 48 }}*/}
                    {/*    >*/}
                    {/*      {*/}
                    {/*        SELECT_DOCUMENT_TYPE_LIST.map((item, index) =>*/}
                    {/*          <Select.Option key={index} value={item.value}>{item.label}</Select.Option>,*/}
                    {/*        )*/}
                    {/*      }*/}
                    {/*    </Select>*/}
                    {/*  </Form.Item>*/}
                    {/*</Col>*/}
                    <Col xs={24} sm={24} md={16} lg={16} xl={16} xxl={16}>
                      <Form.Item
                        label={<>
                          <FormLabel>Số ĐKKD/QĐTL</FormLabel>
                          <FormRequired> * </FormRequired>
                        </>}
                        rules={[{ validator: validator.validateDocumentNumber }]}
                        name={'legalId'}
                      >
                        <Input
                          disabled
                          style={{ height: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'auto' : 48 }}
                          autoComplete={'off'} placeholder={'Nhập nội dung'} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} style={{ textAlign: 'justify' }}>
                      <Form.Item>
                        <TextInform>
                          Hệ thống kiểm tra và xác nhận Quý khách đang không giữ số tài khoản số đẹp nào trước đó. Để
                          hoàn tất quá trình đăng ký số tài khoản Quý khách đang lựa chọn vui lòng nhập thêm các thông
                          tin phía dưới.
                        </TextInform>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                      <Form.Item
                        label={<>
                          <FormLabel>Tên doanh nghiệp</FormLabel>
                          <FormRequired> * </FormRequired>
                        </>}
                        rules={[{ validator: validator.validateCompanyName }]}
                        name={'customerName'}
                      >
                        <Input
                          maxLength={35}
                          style={{ height: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'auto' : 48 }}
                          autoComplete={'off'} placeholder={'Nhập nội dung'} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                      <Form.Item
                        label={<>
                          <FormLabel>Tên người liên hệ</FormLabel>
                          <FormRequired> * </FormRequired>
                        </>}
                        rules={[{ validator: validator.validateContactName }]}
                        name={'contact'}
                      >
                        <Input
                          maxLength={70}
                          style={{ height: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'auto' : 48 }}
                          autoComplete={'off'} placeholder={'Nhập nội dung'} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                      <Form.Item
                        label={<>
                          <FormLabel>Email người liên hệ</FormLabel>
                          <FormRequired> * </FormRequired>
                        </>}
                        rules={[{ validator: validator.validateContactEmail }]}
                        name={'email'}
                      >
                        <Input
                          maxLength={35}
                          style={{ height: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'auto' : 48 }}
                          autoComplete={'off'} placeholder={'Nhập nội dung'} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                      <Form.Item
                        label={<>
                          <FormLabel>SĐT người liên hệ</FormLabel>
                          <FormRequired> * </FormRequired>
                        </>}
                        name={'phoneNumber'}
                        rules={[{ validator: validator.validateContactPhone }]}
                      >
                        <Input
                          maxLength={10}
                          style={{ height: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'auto' : 48 }}
                          autoComplete={'off'} placeholder={'Nhập nội dung'} />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12} id={'provinceIdWrap'}>
                      <Form.Item
                        label={<>
                          <FormLabel>Tỉnh/Thành phố</FormLabel>
                          <FormRequired> * </FormRequired>
                        </>}
                        rules={[{ validator: validator.validateCity }]}
                        name={'provinceId'}
                      >
                        <Select
                          getPopupContainer={(triggerNode) => triggerNode.parentNode}
                          style={{ height: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'auto' : 48 }}
                          showSearch
                          allowClear
                          onChange={handleChangeProvince}
                          optionFilterProp={'name'}
                          placeholder={'Chọn Tỉnh/Thành phố'}>
                          {
                            listProvince && listProvince.map(item =>
                              <Select.Option
                                key={item.provinceId}
                                name={`${item.description} ${stringUtils.removeVietnameseCharMark(item.description)}`}
                                value={item.provinceId}>
                                {item.description}
                              </Select.Option>,
                            )
                          }
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                      <Form.Item
                        label={<>
                          <FormLabel>Quận/Huyện</FormLabel>
                          <FormRequired> * </FormRequired>
                        </>}
                        rules={[{ validator: validator.validateDistrict }]}
                        name={'districtId'}
                      >
                        <Select
                          getPopupContainer={(triggerNode) => triggerNode.parentNode}
                          style={{ height: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'auto' : 48 }}
                          showSearch
                          allowClear
                          onChange={handleChangeDistrict}
                          optionFilterProp={'name'}
                          placeholder={'Chọn Quận/Huyện'}>
                          {
                            listDistrict && listDistrict.map(item =>
                              <Select.Option
                                key={item.districtId}
                                name={`${item.description} ${stringUtils.removeVietnameseCharMark(item.description)}`}
                                value={item.districtId}>
                                {item.description}
                              </Select.Option>,
                            )
                          }
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                      <Form.Item
                        label={<>
                          <FormLabel>Phường/Xã</FormLabel>
                          <FormRequired> * </FormRequired>
                        </>}
                        rules={[{ validator: validator.validateWards }]}
                        name={'wardId'}
                      >
                        <Select
                          getPopupContainer={(triggerNode) => triggerNode.parentNode}
                          style={{ height: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'auto' : 48 }}
                          showSearch
                          allowClear
                          optionFilterProp={'name'}
                          placeholder={'Chọn Phường/Xã'}>
                          {
                            listWard && listWard.map(item =>
                              <Select.Option
                                key={item.wardId}
                                name={`${item.description} ${stringUtils.removeVietnameseCharMark(item.description)}`}
                                value={item.wardId}>
                                {item.description}
                              </Select.Option>,
                            )
                          }
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                      <Form.Item
                        label={<>
                          <FormLabel>Chi nhánh</FormLabel>
                          <FormRequired> * </FormRequired>
                        </>}
                        rules={[{ validator: validator.validateBranch }]}
                        name={'branchCode'}
                      >
                        <Select
                          getPopupContainer={(triggerNode) => triggerNode.parentNode}
                          style={{ height: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'auto' : 48 }}
                          placeholder={'Chọn'}>
                          {
                            listBranch && listBranch.map(item =>
                              <Select.Option
                                key={item.branchId}
                                name={`${item.name} ${stringUtils.removeVietnameseCharMark(item.name)}`}
                                value={item.code}>
                                {item.name}
                              </Select.Option>,
                            )
                          }
                          {/*<Select.Option*/}
                          {/*  key={1111}*/}
                          {/*  name={'chi nhanh xxxx'}*/}
                          {/*  value={'VN0010193'}>*/}
                          {/*  Chi nhánh test*/}
                          {/*</Select.Option>*/}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                      <Form.Item
                        label={<>
                          <FormLabel>Mã cán bộ giới thiệu</FormLabel>
                          {/*<FormRequired> * </FormRequired>*/}
                        </>}
                        rules={[{ validator: validator.validateReferCode }]}
                        name={'dao'}
                      >
                        <Input
                          maxLength={10}
                          style={{ height: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'auto' : 48 }}
                          autoComplete={'off'} placeholder={'Nhập nội dung'} />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}
                      style={{ textAlign: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'center' : 'left' }}
                      order={(breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 2 : 1}
                    >
                      <Button
                        style={{
                          minWidth: 120,
                          background: '#EAEAEA',
                          border: '1px solid #EAEAEA',
                          color: '#818181',
                        }}
                        block={(breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM)}
                        type={'default'}
                        onClick={handleClickCancel}
                      >
                        Hủy bỏ
                      </Button>
                    </Col>
                    <Col
                      xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}
                      style={{ textAlign: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'center' : 'right' }}
                      order={(breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 1 : 2}
                    >
                      <Button
                        style={{ minWidth: 120 }}
                        block={(breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM)}
                        type={'primary'} htmlType={'submit'}
                      >
                        Tiếp tục
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </ConditionRender>
          <ConditionRender visible={progressStep === 2}>
            <OtpForm
              payloadResend={resendOtpData}
              description={`VPBank đã gửi mã OTP đến email`}
              receivedOtp={payloadData?.email}
              expiredCountTime={180}
              resendCountTime={30}
              visible={true}
              callbackOtp={handleSubmitOTP}
              callbackResend={handleCallbackResend}
              onCancel={() => {
                onCancel && onCancel()
              }} />
          </ConditionRender>
          <ConditionRender visible={progressStep === 3}>
            <StepFinal
              textAlign={'left'}
              textLine1A={finalContent?.textLine1A}
              variableLine1={finalContent?.variableLine1}
              textLine2={finalContent?.textLine2}
              textLine3={finalContent?.textLine3}
              textLine4={finalContent?.textLine4}
              buttonText={finalContent?.buttonText}
              buttonLink={finalContent?.buttonLink}
            />
          </ConditionRender>
        </FormWrapper>
      </Container>
    </Step3BNotHoldWrapper>
  )
})


Step3BNotHold.propTypes = {
  onClickBack: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  accountInfo: PropTypes.object.isRequired,
}

export default Step3BNotHold
